import { render, staticRenderFns } from "./jobsErp.vue?vue&type=template&id=c2ec04dc&scoped=true&"
import script from "./jobsErp.vue?vue&type=script&lang=js&"
export * from "./jobsErp.vue?vue&type=script&lang=js&"
import style0 from "./jobsErp.vue?vue&type=style&index=0&id=c2ec04dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ec04dc",
  null
  
)

export default component.exports